"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogLogger = exports.datadogReporter = void 0;
const browser_logs_1 = require("@datadog/browser-logs");
const browser_rum_1 = require("@datadog/browser-rum");
const __1 = require("..");
function getDatadogStatusType(level) {
    switch (level) {
        case __1.LogLevel.Error:
            return browser_logs_1.StatusType.error;
        case __1.LogLevel.Warn:
            return browser_logs_1.StatusType.warn;
        case __1.LogLevel.Info:
            return browser_logs_1.StatusType.info;
        case __1.LogLevel.Debug:
        default:
            return browser_logs_1.StatusType.debug;
    }
}
function datadogReporter(info, config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const isLocalhost = window.location.hostname === 'localhost';
    browser_logs_1.datadogLogs.init({
        site: config.site,
        proxyUrl: config.proxyUrl,
        clientToken: config.clientToken,
        service: info.service,
        env: info.environment,
        version: (_a = config.version) !== null && _a !== void 0 ? _a : info.version,
        useSecureSessionCookie: (_b = config.useSecureSessionCookie) !== null && _b !== void 0 ? _b : !isLocalhost,
        useCrossSiteSessionCookie: (_c = config.useCrossSiteSessionCookie) !== null && _c !== void 0 ? _c : false,
        trackSessionAcrossSubdomains: config.trackSessionAcrossSubdomains,
        forwardErrorsToLogs: (_d = config.forwardConsoleLogs) !== null && _d !== void 0 ? _d : false,
    });
    browser_rum_1.datadogRum.init({
        site: config.site,
        proxyUrl: config.proxyUrl,
        clientToken: config.clientToken,
        applicationId: config.applicationId,
        service: info.service,
        env: info.environment,
        version: (_e = config.version) !== null && _e !== void 0 ? _e : info.version,
        useSecureSessionCookie: (_f = config.useSecureSessionCookie) !== null && _f !== void 0 ? _f : !isLocalhost,
        useCrossSiteSessionCookie: (_g = config.useCrossSiteSessionCookie) !== null && _g !== void 0 ? _g : false,
        trackSessionAcrossSubdomains: config.trackSessionAcrossSubdomains,
        // Set sampleRate to 100 to capture 100%
        // of transactions for performance monitoring.
        sampleRate: (_h = config.sampleRate) !== null && _h !== void 0 ? _h : 100,
        replaySampleRate: (_j = config.replaySampleRate) !== null && _j !== void 0 ? _j : 100,
        trackInteractions: (_k = config.trackInteractions) !== null && _k !== void 0 ? _k : false,
        defaultPrivacyLevel: (_l = config.defaultPrivacyLevel) !== null && _l !== void 0 ? _l : 'mask-user-input',
        allowedTracingOrigins: config.allowedTracingOrigins,
        actionNameAttribute: (_m = config.actionNameAttribute) !== null && _m !== void 0 ? _m : 'data-analytics-name',
        trackViewsManually: (_o = config.trackViewsManually) !== null && _o !== void 0 ? _o : false,
    });
    const reporter = {
        trackEvent: function (event) {
            var _a, _b;
            const context = {
                level: event.level,
                ...event.metadata,
                ...event.tags,
                ...event.metrics,
            };
            browser_rum_1.datadogRum.addAction(event.message, context);
            (_a = browser_logs_1.datadogLogs.logger) === null || _a === void 0 ? void 0 : _a.log(event.message, context, getDatadogStatusType((_b = event.level) !== null && _b !== void 0 ? _b : __1.LogLevel.Info));
        },
        addBreadcrumb: function (breadcrumb) {
            const context = {
                ...breadcrumb.metadata,
                category: breadcrumb.category,
            };
            browser_rum_1.datadogRum.addAction(breadcrumb.message, context);
        },
        addMetadata: function (metadata) {
            for (const [key, value] of Object.entries(metadata)) {
                if (value !== null) {
                    browser_rum_1.datadogRum.addRumGlobalContext(key, value);
                    browser_logs_1.datadogLogs.addLoggerGlobalContext(key, value);
                }
                else {
                    browser_rum_1.datadogRum.removeRumGlobalContext(key);
                    browser_logs_1.datadogLogs.removeLoggerGlobalContext(key);
                }
            }
        },
        setUser: function (user) {
            var _a;
            if (user) {
                browser_rum_1.datadogRum.setUser({
                    id: user.id,
                    email: user.email,
                    name: (_a = user.name) !== null && _a !== void 0 ? _a : user.email,
                });
                browser_logs_1.datadogLogs.addLoggerGlobalContext('user_id', user.id);
                browser_logs_1.datadogLogs.addLoggerGlobalContext('user_email', user.email);
                browser_logs_1.datadogLogs.addLoggerGlobalContext('user_username', user.username);
            }
            else {
                browser_rum_1.datadogRum.removeUser();
                browser_logs_1.datadogLogs.removeLoggerGlobalContext('user_id');
                browser_logs_1.datadogLogs.removeLoggerGlobalContext('user_email');
                browser_logs_1.datadogLogs.removeLoggerGlobalContext('user_username');
            }
        },
        setRouteName: function (routeName) {
            reporter.addMetadata({ routeName });
        },
        setPageName: function (pageName) {
            if (config.trackViewsManually) {
                browser_rum_1.datadogRum.startView(pageName);
            }
            else {
                reporter.addMetadata({ pageName });
            }
        },
        reportError: function (error, metadata) {
            // Note, datadog should pick up the console error above
            browser_rum_1.datadogRum.addError(error, metadata);
        },
        recordSession: function () {
            browser_rum_1.datadogRum.startSessionReplayRecording();
        },
        recordSessionStop: function () {
            browser_rum_1.datadogRum.stopSessionReplayRecording();
        },
    };
    return reporter;
}
exports.datadogReporter = datadogReporter;
function datadogLogger(name, options) {
    const loggerName = name !== null && name !== void 0 ? name : 'root';
    const ddLogger = browser_logs_1.datadogLogs.createLogger(loggerName, {
        context: options === null || options === void 0 ? void 0 : options.metadata,
    });
    // Send to datadog and console.
    ddLogger.setHandler([browser_logs_1.HandlerType.http, browser_logs_1.HandlerType.console]);
    const logger = {
        startTimer: function () {
            const start = new Date();
            return {
                logger: this,
                done: ({ message, level } = {}) => {
                    const duration = new Date().getTime() - start.getTime();
                    logger[level !== null && level !== void 0 ? level : __1.LogLevel.Info](message !== null && message !== void 0 ? message : 'Timer Completed', { duration });
                    return true;
                },
            };
        },
        child: function (metadata, name) {
            return datadogLogger(name !== null && name !== void 0 ? name : `${loggerName}.child`, metadata);
        },
        log: (level, message, metadata) => {
            switch (level) {
                case __1.LogLevel.Debug:
                    ddLogger.debug(message, metadata);
                    break;
                case __1.LogLevel.Info:
                    ddLogger.info(message, metadata);
                    break;
                case __1.LogLevel.Warn:
                    ddLogger.warn(message, metadata);
                    break;
                case __1.LogLevel.Error:
                    ddLogger.error(message, metadata);
                    break;
            }
            return logger;
        },
        debug: (message, metadata) => logger.log(__1.LogLevel.Debug, message, metadata),
        info: (message, metadata) => logger.log(__1.LogLevel.Info, message, metadata),
        warn: (message, metadata) => logger.log(__1.LogLevel.Warn, message, metadata),
        error: (message, metadata) => logger.log(__1.LogLevel.Error, message, metadata),
    };
    return logger;
}
exports.datadogLogger = datadogLogger;
//# sourceMappingURL=datadogReporter.js.map